import { Suspense, useEffect, useState } from "react";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import Spinner from "../../components/UI/Spinner/Spinner";
const BUAP = (props) => {
  const [view, setView] = useState(null);

  useEffect(() => {
    const path = window.location.pathname;
    if (path === "/includes/tel_email_dir/tel_email.php") {
      window.location =
        "https://obuap.bethlehem.edu/includes/tel_email_dir/tel_email.php";
    }

    if (path === "/index2.php") {
      window.location = "https://buap.bethlehem.edu/";
    }

    window.location = "https://mybu.bethlehem.edu/";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Suspense fallback={<Spinner />}>{view}</Suspense>;
};

export default withErrorHandler(BUAP);
